<div class="home-page">
  <h1>BARE Reporting</h1>
  <p class="contact">
    Questions? Contact
    <a [href]="'mailto:' + contact.email">{{ contact.name }}</a>
  </p>
</div>
